"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getPostboxDocuments = getPostboxDocuments;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _postboxTableBodyHelper = require("../../common/features/PostBox/postboxTableBodyHelper");
function getPostboxDocuments() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/documents"));
}
function initDownloadPostboxDocument(documentId, cb) {
  var url = "".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/documents/").concat(documentId, "?filenameEncoding=").concat((0, _postboxTableBodyHelper.filenameEncoding)());
  _RestHelper.default.downloadContentWithPost(documentId, url, [], cb);
}
var _default = exports.default = {
  initDownloadPostboxDocument: initDownloadPostboxDocument,
  getPostboxDocuments: getPostboxDocuments
};